import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, Injector, APP_ID, inject, provideAppInitializer } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  ComponentsModule,
  httpLoaderFactory,
} from './components/components.module';
import { HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NavbarComponent } from './elements/navbar/navbar.component';
import { OverviewModule } from './modules/overview/overview.module';
import { DetailModule } from './modules/detail/detail.module';
import { ProfileModule } from './modules/profile/profile.module';
import { AuthModule } from './modules/auth/auth.module';
import { CreateEventModule } from './modules/create-event/create-event.module';
import { InfoModule } from './modules/info/info.module';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { UserModule } from './modules/user/user.module';
import { VersionCheckService } from './services/version-check-service';
import { AdsModule } from './modules/ads/ads.module';
import { VideoModule } from './modules/video/video.module';
import { AppConfigService } from './services/app-config.service';
import { StatuscodesModule } from './modules/statuscodes/statuscodes.module';
import { VideoToThumbnailService } from './services/video-to-thumbnail.service';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SebbiesModule } from './modules/sebbies/sebbies.module';
import { StreapperModule } from './modules/streapper/streapper.module';
import { SubscriptionModule } from './modules/subscription/subscription.module';

const appInitializerFn = (appConfig: AppConfigService) => {
  return async () => {
    return await appConfig.loadAppConfig();
  };
};

@NgModule({
  declarations: [AppComponent, NavbarComponent],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    MatDialogModule,
    ComponentsModule,
    OverviewModule,
    AdsModule,
    InfoModule,
    ProfileModule,
    UserModule,
    StreapperModule,
    AuthModule,
    DetailModule,
    SubscriptionModule,
    VideoModule,
    CreateEventModule,
    StatuscodesModule,
    SebbiesModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),
  ],
  providers: [
    Title,
    VideoToThumbnailService,
    AppConfigService,
    provideAppInitializer(() => {
      const initializerFn = (appInitializerFn)(inject(AppConfigService));
      return initializerFn();
    }),
    VersionCheckService,
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
    { provide: APP_ID, useValue: 'streapp-website' },
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
  ],
})
export class AppSharedModule { }
